import React, { useEffect } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import useGetData from "../Custom-Hooks/useGetData";
import GlobalLoader from "../shared/GlobalLoader";
import { getCurrentFormattedMonthYear } from "../../utils/dateUtils";
import { useLoading } from "../../context/LoadingContext";

const SystemAnalysis = ({ setType }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const selectedCustomerId = localStorage.getItem("customerId") || 0;
  const selectedLocationId = localStorage.getItem("selectedLocationId") || 0;
  const currentdate = getCurrentFormattedMonthYear();
  const { getLoading, setLoading } = useLoading();

  useEffect(() => {
    localStorage.removeItem("systemAnalysisSelectedButton");
  }, []);

  // Fetch system analysis data from API
  const { data: systemAnalysisData, isLoading, error } = useGetData(
    `${baseUrl}/customer/systems_analysis/${selectedCustomerId}/${selectedLocationId}`
  );

  useEffect(() => {
  if (!systemAnalysisData && !error) {
    setLoading(true);
  } else {
    setLoading(false);
  }
}, [systemAnalysisData, error, setLoading]);
  

  const calculateTotalIssues = (data) => {
    let totalIssues = 0;
    for (const category in data.overlay.equipementData) {
      totalIssues += data.overlay.equipementData[category].issues;
    }
    return totalIssues;
  };

  const getButtonLabel = (key) => {
    const labels = {
      LLT: "Low‑Low Temperature (LLT)",
      LT: "Low Temperature (LT)",
      MT: "Medium Temperature (MT)",
      HT: "High Temperature (HT)",
      HHT: "High‑High Temperature (HHT)",
    };
    return labels[key] || key;
  };

  const hasEquipmentData =
    systemAnalysisData?.overlay?.equipementData &&
    Object.keys(systemAnalysisData.overlay.equipementData).length > 0;

  return (
    <div>
      {isLoading && getLoading && <GlobalLoader />}

      <div className="col-12 px-3 py-4 d-flex align-items-center justify-content-between">
        <div>
          <div className="fnt14 fw-600">System Analysis</div>
          {systemAnalysisData?.updated_at &&
            <div className="fnt12 fw-500 text-secondary">
              MEB&nbsp;–&nbsp;
              {new Date(systemAnalysisData.updated_at).toLocaleDateString('en-US', {
                month: 'short',
                year: 'numeric'
              })}
            </div>
          }
        </div>

        <div>
          {systemAnalysisData ? (
            <div className="default-button">
              {calculateTotalIssues(systemAnalysisData)} Issues
            </div>
          ) : (
            <div className="default-button">0 Issues</div>
          )}
        </div>
      </div>

      {!isLoading && (
        <div className="col-12 px-3">
          {hasEquipmentData ? (
            <div className="temperature-container">
              {["LLT", "LT", "MT", "HT", "HHT"].map((key) => {
                const entry = systemAnalysisData.overlay.equipementData[key] || {};
                const { issues = 0, noIssues = 0 } = entry;

                let linkColor = "gray";
                if (issues > 0) linkColor = "orange";
                else if (noIssues > 0) linkColor = "green";

                return (
                  <div
                    key={key}
                    className={`temperature-item ${issues === 0 && noIssues === 0 ? "disabled" : ""
                      }`}
                  >
                    <span>{getButtonLabel(key)}</span>
                    <Link
                      to="/dashboard/system-analysis"
                      state={{ type: key, data: systemAnalysisData }}
                      className={`icon-container ${linkColor}`}
                    >
                      <FaExternalLinkAlt />
                    </Link>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="fnt12 d-flex align-items-center justify-content-center height-150">
              No data to display
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SystemAnalysis;